module.exports = __webpack_public_path__ + "img/accountAuth.8a11cdf9.png";